"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Timezone = void 0;
var moment = require("moment-timezone");
var tz_offset_1 = require("./tz-offset");
var Timezone = /** @class */ (function () {
    function Timezone(timezone) {
        this.timezone = timezone;
    }
    Timezone.prototype.getOffset = function (date) {
        return new tz_offset_1.TimezoneOffset(moment(date).tz(this.timezone).format('Z'));
    };
    Timezone.prototype.getShort = function (date) {
        return moment(date).tz(this.timezone).format('z');
    };
    return Timezone;
}());
exports.Timezone = Timezone;
